import { Component, EventEmitter, OnInit, Output, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import swal from 'sweetalert2';
import { ServiceClientQuestions } from '../../../../shared/models/service-client-questions.model';
import { ServiceClientUserAnswers } from '../../../../shared/models/service-client-user-answers.model';
import { serviceClientService } from '../../../../shared/services/serviceClient.service';


@Component({
  selector: 'app-modal-security-questions',
  templateUrl: './modal-security-questions.component.html',
  styleUrls: ['./modal-security-questions.component.css']
})
export class ModalSecurityQuestionsComponent implements OnInit {

  @ViewChild('modalSecurityQuestions') modalSecurityQuestions: TemplateRef<any>;

  @ViewChild('vc', {read: ViewContainerRef}) vc: ViewContainerRef;

  @Output() userAnswers = new EventEmitter<boolean>();

  showSpinnerLoading: boolean;

  public documentTypeBeneficiary: string;

  public documentIdBeneficiary: string;

  // Lista de preguntas
  public listServiceClientQuestions: ServiceClientQuestions[] = [];

  // Lista de respuestas que selecciona el usuario
  public serviceClientUserAnswers : ServiceClientUserAnswers[] = [];
  

  constructor(
    private _serviceClient: serviceClientService
  ) { }


  ngOnInit() {
  }


  showDialog(documentTypeBeneficiary: string, documentIdBeneficiary: string) {
    this.documentTypeBeneficiary = this.getDocumentType(documentTypeBeneficiary);
    this.documentIdBeneficiary = documentIdBeneficiary;

    this.getQuestions();

    let view = this.modalSecurityQuestions.createEmbeddedView(null);
    this.vc.insert(view);
    this.modalSecurityQuestions.elementRef.nativeElement.previousElementSibling.classList.remove('fade');
    this.modalSecurityQuestions.elementRef.nativeElement.previousElementSibling.classList.add('modal-open'); 
    this.modalSecurityQuestions.elementRef.nativeElement.previousElementSibling.style.display = 'block';
  }


  public getDocumentType(value: string): string {
    switch(value) {

      case "CEDULA DE CIUDADANIA":
        return "CC";

      case "CARNE DIPLOMATICO":
          return "CD";

      case "CEDULA EXTRANJERI":
        return "CE";

      case "IDENTIFICACION DIPLO":
        return "ID";

      case "PERSONERIA JURIDICA":
        return "PJ";

      case "CERTIFICADO DE NACID":
          return "CN";

      case "REGISTRO MERCANTIL":
        return "RM";

      case "NUMERO DE IDENTIFICA":
        return "NIT";

      case "PASAPORTE":
        return "PA";

      case "REGISTRO CIVIL":
        return "RC";

      case "NUMERO DE SOLICITUD":
        return "NS";

      case "TARJETA IDENTIDAD":
        return "TI";

      case "NUMERO UNICO DE IDEN":
        return "NUIP";

      case "PERMISO ESPECIAL":
        return "PEP";

      case "MATRIZ DE COLECTIVO":
        return "COLE";

      case "TIPO DE IDENTIFICACI":
        return "TE";

      case "MENOR SIN IDENTIFICA":
        return "MSI";

      case "ADULTO SIN IDENTIFIC":
        return "ASI";

      default:

    }
  }


  public getQuestions() {
    this.showSpinnerLoading = true;
    this._serviceClient.getQuestions(this.documentTypeBeneficiary, this.documentIdBeneficiary).subscribe(
      res => {
        this.listServiceClientQuestions = res;
        this.showSpinnerLoading = false;
      },
      err => {
        console.log(err);
        this.showSpinnerLoading = false;
        this.showSwalError(err.error.message);
      }
    );
  }


  public showSwalError(message: string) {
    swal({
      title: 'Error',
      html: '<p style="font-size:14px"> ' + message + '</p>',
      type: 'warning',
      confirmButtonClass: 'btn btn-primary',
      buttonsStyling: false,
      focusConfirm: false
    });
    return;
  }


  public selectAnswer(idQuestion: string, idControl: string) {
    /* Si ya hay una respuesta de la pregunta seleccionada anteriormente
    y se vuelve a seleccionar otra, se elimina la anterior y se
    añade la nueva respuesta seleccionada.*/

    if(this.serviceClientUserAnswers.find(ca => ca.idPregunta == Number(idQuestion)) != null) {
      var oldUserAnswerIndex = this.serviceClientUserAnswers.findIndex(ca => ca.idPregunta == Number(idQuestion));
      this.serviceClientUserAnswers.splice(oldUserAnswerIndex, 1);

      var userAnswer: ServiceClientUserAnswers = new ServiceClientUserAnswers();
      userAnswer.idPregunta = Number(idQuestion);
      userAnswer.idControl = Number(idControl);

      this.serviceClientUserAnswers.push(userAnswer);
    }
    /* Si no hay una respuesta de la pregunta 
    seleccionada anteriormente, se añade la nueva.*/

    else {
      var userAnswer: ServiceClientUserAnswers = new ServiceClientUserAnswers();
      userAnswer.idPregunta = Number(idQuestion);
      userAnswer.idControl = Number(idControl);

      this.serviceClientUserAnswers.push(userAnswer);
    }
  }


  public validateAnswers() {
    if(this.serviceClientUserAnswers.length == this.listServiceClientQuestions.length
      && this.listServiceClientQuestions.length > 0) {
      
      this._serviceClient.validateAnswers(this.documentTypeBeneficiary, 
        this.documentIdBeneficiary, 
        this.serviceClientUserAnswers)
      .subscribe(
        res => {
          this.getUserAnswers(res);
        },
        err => {
          console.log(err);
          this.showSwalError(err.error.message);
        }
      );
      
      //this.getUserAnswers(true);
    }
    else{
      this.showSwalError('Debe responder todas las preguntas.');
    }
  }


  public getUserAnswers(result: boolean) {

    if(result) {
      this.userAnswers.emit(result);
      this.closeDialog();
    }
    else {
      this.serviceClientUserAnswers = [];
      this.showSwalError('No respondio correctamente las preguntas. Por favor intente responder las nuevas preguntas correctamente.');
      this.getQuestions();
    }
  }


  closeDialog() {
    this.listServiceClientQuestions = [];
    this.serviceClientUserAnswers = [];
    this.vc.clear();
  }

}



// WEBPACK FOOTER //
// /app/src/app/office/laboratory-tests/modals/modal-security-questions/modal-security-questions.component.ts